import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useRemoveRiwayatPendidikan } from "../../../../api/effects/mutations/RiwayatPendidikan/removeRiwayatPendidikan";
import useFetchAllRiwayatPendidikan from "../../../../api/effects/queries/RiwayatPendidikan/useFetchAllRiwayatPendidikan";
import { RemoveModal } from "../../../../components/RemoveModal";
import { RiwayatPendidikanResponse } from "../../../../models/RiwayatPendidikan";
import ProfileState from "../../../../recoil/ProfileState";
import { convertDate } from "../../../../utils/dateConvert";
import RiwayatPendidikanModal from "./RiwayatPendidikanModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

type Props = {
  data: RiwayatPendidikanResponse[];
};

export default function RiwayatPendidikanTable({ data }: Props) {
  const recoilValue = useRecoilValue(ProfileState);

  const [modalState, setModalState] = useState(false);
  const [editId, setEditId] = useState<number | null>(null);

  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const { mutateAsync: RemoveRiwayatPendidikan } = useRemoveRiwayatPendidikan({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });
  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveRiwayatPendidikan(deletingId);
      handleCloseRemoveModal();
    }
  };
  const handleOpenEditModal = () => setModalState(true);
  const handleCloseEditModal = () => setModalState(false);


  const handleClick = (id: number) => {
    setEditId(id);
    handleOpenEditModal();
  };



  return (
    <Grid container justifyContent="center">
      <RiwayatPendidikanModal
        open={modalState}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Institusi</TableCell>
                <TableCell>Kota</TableCell>
                <TableCell>Jenjang Pendidikan</TableCell>
                <TableCell>Jurusan</TableCell>
                <TableCell>Tahun Mulai</TableCell>
                <TableCell>Tahun Selesai</TableCell>
                <TableCell>Pembiyaan</TableCell>
                <TableCell align="center">Lulus</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow
                  key={row.RIWAYAT_PENDIDIKAN_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() => handleClick(row.RIWAYAT_PENDIDIKAN_ID)}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.NAMA_INSTITUSI}</TableCell>
                  <TableCell>{row.KOTA}</TableCell>
                  <TableCell>{row.PENDIDIKAN_ID}</TableCell>
                  <TableCell>{row.JURUSAN}</TableCell>
                  <TableCell>{convertDate(row.TAHUN_MULAI)}</TableCell>
                  <TableCell>{convertDate(row.TAHUN_SELESAI)}</TableCell>
                  <TableCell>{row.PEMBIAYAAN}</TableCell>
                  <TableCell align="center">
                    {row.LULUS ? "Ya" : "Tidak"}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(
                          `${row.NAMA_INSTITUSI} ${row.PENDIDIKAN_ID} ${row.JURUSAN}`,
                          row.RIWAYAT_PENDIDIKAN_ID
                        )
                      }
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography color="error">
          *Wajib diisi Pendidikan SD, SMP, dan SMA, sampai dengan Pendidikan Terakhir
        </Typography>
      </SquareGrid>
    </Grid>
  );
}
